import Spinner from '@components/spinner/Spinner';
import { useFetchLatestChatId, useFetchTeamMembers, useSingleInterview } from '@hooks/getQueries';
import { useUserPermission } from '@hooks/userPermission';
import { Suspense, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ChatWithDataMain from '@components/chat-with-data/ChatWithDataMain';

import { newChat } from '@utils/constants';

export default function ChatWithDataContainer() {
  const navigate = useNavigate();
  const { id, chatId } = useParams();
  const { data: interview } = useSingleInterview(id);
  const { data: teamMembers } = useFetchTeamMembers({
    studyId: id,
    studyUrlType: 'qualitative-studies',
  });
  const { data: paramChatId, isLoading: isGettingPreviousChat } = useFetchLatestChatId(id);

  const { canEdit } = useUserPermission({
    entity: interview,
    teamMembers: teamMembers,
  });

  useEffect(() => {
    if (!paramChatId || chatId === newChat) return;
    if (!paramChatId?.chat_id) return;
    if (!chatId || chatId === 'undefined') {
      navigate(`/interview/${id}/chat-with-data/${paramChatId?.chat_id}`, { replace: true });
    }
  }, [paramChatId, chatId, id, navigate]);

  return (
    <Suspense fallback={<Spinner />}>
      <ChatWithDataMain
        studyType="interview"
        canManageReport={canEdit}
        id={id}
        paramChatId={paramChatId?.chat_id}
        newChatId={chatId}
        isGettingPreviousChat={isGettingPreviousChat}
      />
    </Suspense>
  );
}
